export default "__VITE_ASSET__Dxwri0$3__"